import { CaretIconProps } from "./Sidebar.types"

export const CaretIcon = ({ isOpen }: CaretIconProps) => {
    return (
        <span>
            <CaretSVG isOpen={isOpen} />
        </span>
    )
}

const CaretSVG = ({ isOpen }: CaretIconProps) => {
    return (
        <svg className={`side-menu-caret-icon ${isOpen ? "open" : ""}`} viewBox="0 0 1024 1024" fill="#000">
            <g id="carat-down">
                <path d="M974.17 221.222l28.414 29.781c28.799 30.184 28.518 77.753-0.634 107.596l-434.542 444.836c-29.893 30.601-78.933 31.176-109.534 1.282-0.432-0.422-0.859-0.85-1.282-1.282l-434.542-444.836c-29.152-29.842-29.433-77.412-0.634-107.596l28.414-29.781c29.531-30.952 78.56-32.103 109.512-2.573 0.702 0.669 1.391 1.352 2.067 2.048l350.592 360.609 350.592-360.609c29.82-30.672 78.859-31.363 109.531-1.543 0.696 0.677 1.379 1.365 2.048 2.067z"></path>
            </g>
        </svg>
    )
}
